var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 188,
    viewBox: "0 0 199 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 188
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_6",
    "data-name": "Artboard \\u2013 6",
    clipPath: "url(#clip-Artboard_6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M327.671,421.058l67.668,3.068a16.35,16.35,0,0,1,3.916,4.156c2.377,3.249,11.695,22.3-8.649,28.824s-33.249-.818-33.249-.818a45.742,45.742,0,0,0-8.522-9.491c-4.972-4-25.581-19.373-28.623-20.129s7.472-5.6,7.472-5.6Z",
    transform: "translate(-204.412 -272.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M197.76,180.866c20.1-36.082,16.207-76.588-8.7-90.474s-61.4,4.109-81.5,40.191-16.207,76.588,8.7,90.474S177.656,216.948,197.76,180.866Z",
    transform: "translate(-72.519 -75.656)",
    fill: "#f15f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M178.3,62.8l-2.114.354a1.243,1.243,0,0,0-1.021,1.432l.355,2.115a1.243,1.243,0,0,0,1.431,1.021l2.114-.354a1.243,1.243,0,0,0,1.021-1.432l-.354-2.115A1.244,1.244,0,0,0,178.3,62.8Z",
    transform: "translate(-119.69 -62.221)",
    fill: "#ff9090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M170.113,366.233l-2.114.354a1.243,1.243,0,0,0-1.021,1.431l.355,2.115a1.243,1.243,0,0,0,1.431,1.021l2.115-.354a1.243,1.243,0,0,0,1.021-1.431l-.354-2.114A1.244,1.244,0,0,0,170.113,366.233Z",
    transform: "translate(-114.887 -240.118)",
    fill: "#e3b403"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M53.24,226.709l-1.193,1.471a1.443,1.443,0,0,1-2.042.211L48.535,227.2a1.446,1.446,0,0,0-2.042.211l-2.571,3.162a1.447,1.447,0,0,0,.211,2.042l1.471,1.194a1.444,1.444,0,0,1,.211,2.043l-1.193,1.471a1.447,1.447,0,0,0,.211,2.042l3.162,2.572a1.447,1.447,0,0,0,2.042-.211l1.193-1.471a1.443,1.443,0,0,1,2.042-.211l1.471,1.194a1.446,1.446,0,0,0,2.042-.211l2.571-3.162a1.447,1.447,0,0,0-.211-2.042l-1.471-1.194a1.444,1.444,0,0,1-.211-2.042l1.193-1.471a1.447,1.447,0,0,0-.211-2.042L55.282,226.5A1.447,1.447,0,0,0,53.24,226.709Z",
    transform: "translate(-42.559 -158.012)",
    fill: "#4f80d5",
    stroke: "#4f80d5",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M347.306,190.228l-1.057-.021a.808.808,0,0,1-.794-.824l.02-1.057a.809.809,0,0,0-.794-.824l-2.267-.048a.808.808,0,0,0-.824.794l-.02,1.057a.808.808,0,0,1-.824.794l-1.057-.02a.808.808,0,0,0-.824.794l-.048,2.268a.809.809,0,0,0,.794.824l1.057.021a.808.808,0,0,1,.794.824l-.02,1.057a.809.809,0,0,0,.794.824l2.267.048a.808.808,0,0,0,.824-.794l.02-1.057a.808.808,0,0,1,.824-.794l1.057.02a.808.808,0,0,0,.824-.794l.048-2.268A.809.809,0,0,0,347.306,190.228Z",
    transform: "translate(-215.646 -135.313)",
    fill: "#a880cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M152.54,124.362l45.681-9.084a3.615,3.615,0,0,1,4.334,2.716l16.083,81.643a3.62,3.62,0,0,1-1.931,4.064l-39.8,23.556c-2.108,1.036-5.68-1.783-6.187-4.07l-20.93-94.508a3.626,3.626,0,0,1,2.729-4.32Z",
    transform: "translate(-104.77 -92.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M160.263,127.774l42.983-8.853a3.616,3.616,0,0,1,4.334,2.716l18.789,81.408a3.62,3.62,0,0,1-1.931,4.064L183.6,229.061a3.627,3.627,0,0,1-5.143-2.466l-20.93-94.508a3.626,3.626,0,0,1,2.729-4.32Z",
    transform: "translate(-109.303 -95.078)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M191.07,127.433l.366,2.144a1.952,1.952,0,0,0,2.315,1.585l20.693-4.823a1.947,1.947,0,0,0,1.518-2.285l-.306-1.69-24.59,5.061Z",
    transform: "translate(-129.021 -97.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M224.295,213.052l12.039-10.183s-4.336-6.585-10.843-7.762-9.466,1.22-11.291,2.4c-1.92,1.24-4.975,5.958-4.975,5.958l15.073,9.593Z",
    transform: "translate(-139.666 -139.612)",
    fill: "#4f80d5",
    stroke: "#4f80d5",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M209.217,203.378c.239-.493,3.755-7.431,10.93-8.569,7.471-1.186,16.788,4.236,18.618,14.331,1.569,8.665-4.466,18.19-12.419,19.938-6.389,1.407-11.684-2.922-12.33-3.462",
    transform: "translate(-139.662 -139.53)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M207.324,207.712l.66,3.119a.284.284,0,0,0,.411.19l2.66-1.44",
    transform: "translate(-138.552 -147.189)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M366.492,326.732s2.372,3.913-9.388-10.859-23.072-33.52-34.585-41.009-27.961-12.847-40.63-19.664-19.025-5.25-13.968,2.315,27.494,21.8,27.494,21.8-3.7.619-6.572,5.875-1.4,8.443-1.4,8.443-4.07.643-6.511,6.451-.538,8.906-.538,8.906-6.183,4.169-5.585,9.541a25.639,25.639,0,0,0,9.113,16.785c5.7,4.509,12.89,8.656,17.171,7.964s5.861-3.4,5.682-4.226S291.2,328.919,291.2,328.919",
    transform: "translate(-173.06 -172.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M366.492,326.732s2.372,3.913-9.388-10.859-23.072-33.52-34.585-41.009-27.961-12.847-40.63-19.664-19.025-5.25-13.968,2.315,27.494,21.8,27.494,21.8-3.7.619-6.572,5.875-1.4,8.443-1.4,8.443-4.07.643-6.511,6.451-.538,8.906-.538,8.906-6.183,4.169-5.585,9.541a25.639,25.639,0,0,0,9.113,16.785c5.7,4.509,12.89,8.656,17.171,7.964s5.861-3.4,5.682-4.226S291.2,328.919,291.2,328.919",
    transform: "translate(-173.06 -172.493)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M382.806,480.879s-2.91-6.711-18.487-16.843",
    transform: "translate(-230.597 -297.469)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M347.125,317.5s-5.666,2.007-10.274.884Z",
    transform: "translate(-214.492 -211.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M347.125,317.5s-5.666,2.007-10.274.884",
    transform: "translate(-214.492 -211.558)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M331.185,351.292s-7.75,3.149-13.6,1.214Z",
    transform: "translate(-203.196 -231.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M331.185,351.292s-7.75,3.149-13.6,1.214",
    transform: "translate(-203.196 -231.369)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M313.752,387.066s-10.615-1.477-13.207,1.56Z",
    transform: "translate(-193.207 -252.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M313.752,387.066s-10.615-1.477-13.207,1.56",
    transform: "translate(-193.207 -252.133)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M285.307,108.872s-.146-10.039-9.765-12.45",
    transform: "translate(-178.547 -81.941)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M284.238,85.267s-4.546-8.949-14.249-6.877",
    transform: "translate(-175.292 -71.187)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.64bb1660.svg";
export { ForwardRef as ReactComponent };